<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management',
        }"
        >个人赛赛务工具</el-breadcrumb-item
      >
      <el-breadcrumb-item>考场管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-tabs v-model="activeName" type="card" @tab-click="tabHandleClick">
      <el-tab-pane label="考场管理" name="first">
        <!-- 考场筛选 -->
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">考场筛选</span>
            </el-col>
          </el-row>
          <el-form
            :model="queryForm"
            class="filter_Form"
            label-width="90px"
            ref="queryFormRef"
          >
            <el-row :gutter="50">
              <el-col :span="6">
                <el-form-item label="赛季" prop="season">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.season"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in dict_season"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="赛区" prop="districtId">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.districtId"
                    filterable
                    @change="districtChange"
                  >
                    <el-option
                      v-for="item in dict_district"
                      :key="item.id"
                      :label="item.districtName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="考场类型" prop="roomType">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.roomType"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in roomTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="组别" prop="roomLevel">
                  <el-select
                  placeholder="请选择"
                  style="width: 100%"
                  v-model="queryForm.roomLevel"
                  >
                  <el-option
                      v-for="item in dict_group"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                  ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="isClose">
                  <el-select
                  placeholder="请选择"
                  style="width: 100%"
                  v-model="queryForm.isClose"
                  >
                  <el-option label="开放" :value="1"></el-option>
                  <el-option label="关闭" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row :gutter="20" type="flex" justify="end">
            <el-col :span="2">
              <el-button
                type="primary"
                style="width: 100%"
                @click="handleToSearch"
                >查询</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="primary" plain style="width: 100%" @click="handleToReset"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-card>
        <!-- 考场列表 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">考场列表</span>
            </el-col>
            <el-col :span="12">
              <div class="div_algin_right">
                <el-button class="mr-10" type="primary" plain icon="el-icon-upload2" @click="showImportDialog">批量导入考场</el-button>
                <el-button class="mr-10"  type="primary" plain icon="el-icon-download" @click="exportExcel">考场信息导出</el-button>
                <el-button type="primary" @click="handleToCreate">新建考场</el-button>
              </div>
            </el-col>
          </el-row>
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="dataList"
            border
            stripe
          >
            <el-table-column label="序号" type="index" width="50px"></el-table-column>
            <el-table-column label="赛季" prop="season" width="100px">
              <template slot-scope="{ row }">
                {{ row.season || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="赛区" prop="districtName" width="120px">
              <template slot-scope="{ row }">
                {{ row.districtName || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="考场名称" prop="roomName" width="140px">
              <template slot-scope="{ row }">
                <el-link type="primary" @click="handleToReferee(row)">{{ row.roomName || "-" }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="考场类型" prop="roomType" width="90">
              <template slot-scope="{ row }">
                <el-tag :type="row.roomType === 1 ? '' : 'success'" size="mini">{{ row.roomType === 1 ? '腾讯会议' : '线下考场' }}</el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column :label="queryForm.roomType === 1 ? '会议号' : '详细地址'" prop="roomAddress" width="180px"> -->
            <el-table-column label="会议号" prop="roomAddress" width="110px">
              <template slot-scope="{ row }">
                {{ row.roomType === 1 ? row.roomAddress : "-" }}
              </template>
            </el-table-column>
            <el-table-column label="详细地址" prop="roomAddress">
              <template slot-scope="{ row }">
                {{ row.roomType === 0 ? row.roomAddress : "-" }}
              </template>
            </el-table-column>
            <el-table-column label="组别" prop="roomLevel" :formatter="levelFormat" width="130px"></el-table-column>
            <el-table-column label="场次" prop="timeForm">
              <template slot-scope="{ row }">
                {{ time_form[row.timeForm] || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="开始时间" prop="roomStartTime" width="94px">
              <template slot-scope="{ row }">
                {{ row.roomStartTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="结束时间" prop="roomEndTime" width="94px">
              <template slot-scope="{ row }">
                {{ row.roomEndTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="区域决选形式" prop="roomForm" width="160px" :show-overflow-tooltip="true">
              <template slot-scope="{ row }">
                  {{ row.roomForm || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="考位数量" prop="roomNum">
              <template slot-scope="{ row }">
                {{ row.roomNum || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="已选数量" prop="chooseNum"></el-table-column>
            <el-table-column label="状态" prop="isClose" fixed="right">
              <template slot-scope="{ row }">
                <!-- <el-tag style="margin-right: 8px;" size="mini" :type="row.isClose === 1 ? 'success' : 'danger'">{{row.isClose === 1 ? '开放' : '关闭'}}</el-tag> -->
                <el-switch
                  :active-value="1"
                  :inactive-value="0"
                  v-model="row.isClose"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="stateChange(row)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="160px">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  size="small"
                  style="margin-right: 12px;"
                  @click="showEditDialog(scope.row)"
                  >修改</el-button
                >

                <el-button
                  type="text"
                  size="small"
                  style="margin-right: 12px;"
                  @click="handleToDetails(scope.row)"
                  >选手管理</el-button
                >
                <!-- <el-switch
                  :active-value="1"
                  :inactive-value="0"
                  v-model="scope.row.isClose"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="stateChange(scope.row)">
                </el-switch> -->
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageInfo.pageNum"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pageInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="选考场时间管理" name="second">
        <el-card>
            <el-row class="title_row">
              <el-col>
                <span class="title_class">赛区筛选</span>
              </el-col>
            </el-row>
            <el-form
              label-width="80px"
              ref="queryDistrictTimeFormRef"
              :model="queryDistrictTimeForm"
            >
              <el-row :gutter="50">
                <el-col :span="8">
                  <el-form-item label="赛季" prop="season">
                    <el-select
                      placeholder="默认当前赛季"
                      style="width: 100%"
                      v-model="queryDistrictTimeForm.season"
                    >
                      <el-option
                        v-for="item in dict_season"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictValue"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="赛区" prop="districtTimeId">
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="queryDistrictTimeForm.districtTimeId"
                      clearable
                    >
                      <el-option
                        v-for="item in dict_district"
                        :key="item.id"
                        :label="item.districtName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="赛程" prop="raceSchedule">
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="queryDistrictTimeForm.raceSchedule"
                      clearable
                      disabled
                    >
                      <el-option
                        v-for="item in dict_matchType"
                        :key="item.id"
                        :label="item.scheduleName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-row :gutter="20" type="flex" justify="end">
              <el-col :span="2">
                <el-button
                  type="primary"
                  style="width: 100%"
                  @click="getQueryDistrictTimePage()"
                  >查询</el-button
                >
              </el-col>
              <el-col :span="2">
                <el-button type="primary" plain style="width: 100%" @click="reset"
                  >重置</el-button
                >
              </el-col>
            </el-row>
          </el-card>
          <!-- 赛区列表 -->
          <el-card style="margin-top: 15px">
            <el-row class="el-row" type="flex">
              <el-col :span="12">
                <span class="title_class">赛区列表</span>
              </el-col>
            </el-row>
            <el-table
              header-cell-class-name="tableHeaderStyle"
              changes
              border
              :data="divisionList"
            >
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="赛季" prop="season"></el-table-column>
              <el-table-column
                label="赛区"
                prop="districtTimeName"
              ></el-table-column>
              <el-table-column
                label="赛程"
                prop="districtType"
                :formatter="matchTypeFormatter"
              >
              </el-table-column>
              <el-table-column label="选考场开始时间" prop="chooseRoomStartTime">
                <template slot-scope="scope">
                  {{ scope.row.chooseRoomStartTime }}
                </template></el-table-column
              >
              <el-table-column label="选考场结束时间" prop="chooseRoomEndTime">
                <template slot-scope="scope">
                  {{ scope.row.chooseRoomEndTime }}
                </template></el-table-column
              >
              <el-table-column label="操作" width="160px">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    size="small"
                    @click="showEditDistrictTimeDialog(scope.row)"
                    >修改</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleTimeSizeChange"
              @current-change="handleTimeCurrentChange"
              :current-page="queryDistrictTimeForm.pageNum"
              :page-sizes="[10, 20, 40, 80]"
              :page-size="queryDistrictTimeForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="time_total"
            >
            </el-pagination>
          </el-card>
      </el-tab-pane>
      <el-tab-pane label="考场通用信息设置" name="third">
        <!-- 通用信息 -->
        <el-card>
          <el-row>
            <el-form
              :model="setInfo"
              class="filter_Form"
              label-width="110px"
              ref="setInfoFormRef"
              :rules="setInfoFormRules"
              >
              <el-col :span="6">
                <el-form-item label="赛季" prop="season">
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="setInfo.season"
                      filterable
                      @change="changeFn"
                    >
                      <el-option
                        v-for="item in dict_season"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictValue"
                      ></el-option>
                    </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="赛区" prop="districtId">
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="setInfo.districtId"
                      filterable
                      @change="districtChange"
                    >
                      <el-option
                        v-for="item in dict_district"
                        :key="item.id"
                        :label="item.districtName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item label="区域决选时间" prop="roomTime">
                  <!-- <el-date-picker
                    v-model="setInfo.roomTime"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker> -->
                  <el-input
                    v-model="setInfo.roomTime"
                    placeholder="请输入"
                    type="textarea"
                    :rows="4"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item label="区域决选形式" prop="roomForm">
                  <el-input
                    v-model="setInfo.roomForm"
                    placeholder="请输入区域决选形式，“回车键”换行"
                    type="textarea"
                    :rows="4"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item label="考场地址" prop="roomAddress">
                  <el-input
                    v-model="setInfo.roomAddress"
                    placeholder="请输入全部考场地址"
                    type="textarea"
                    :rows="4"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
          <el-row>
            <el-col :span="14" style="margin-top: 20px; text-align: center;">
              <el-button type="primary" @click="setInfoSave">保 存</el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <!-- 新增、修改考场 -->
    <el-dialog
      :title="`${editType === 0 ? '新建' : '修改'}考场`"
      :visible.sync="dialogVisible"
      width="70%"
      @close="handleCloseDialog"
    >
      <el-form
          :model="dataForm"
          label-width="110px"
          ref="dataFormRef"
          :rules="dataFormRules"
        >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="dataForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="dataForm.districtId"
                @change="distChange"
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="组别" prop="roomLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="dataForm.roomLevel"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考场名称" prop="roomName">
              <el-input
                v-model="dataForm.roomName"
                placeholder="请输入"
                type="text"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考场类型" prop="roomType">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="dataForm.roomType"
              >
                <el-option
                  v-for="item in roomTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="dataForm.roomType === 1 ? '会议号' : '考场地址'" prop="roomAddress">
              <el-input
                v-model="dataForm.roomAddress"
                placeholder="请输入"
                type="text"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考位数量" prop="roomNum">
              <el-input
                v-model="dataForm.roomNum"
                placeholder="请输入"
                type="number"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场次" prop="timeForm">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="dataForm.timeForm"
              >
                <el-option
                  v-for="(item,index) in time_form"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="选区名称" prop="roomCertificate">
              <el-input
                v-model="dataForm.roomCertificate"
                placeholder="请输入10字以内"
                type="text"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="比赛时间" prop="dateRange">
              <el-date-picker
                v-model="dataForm.dateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="daterangeChange">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域决选形式" prop="roomForm">
              <el-input
                v-model="dataForm.roomForm"
                placeholder="请输入区域决选形式，每条需换行处敲“回车键”实现换行"
                type="textarea"
                :rows="4"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注意事项" prop="roomNotice">
              <el-input
                v-model="dataForm.roomNotice"
                :rows="4"
                placeholder="请输入注意事项，每条需换行处敲“回车键”实现换行，不需要输入序号。"
                type="textarea"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleToSubmit">{{editType === 0 ? '新 建' : '保存修改'}}</el-button>
      </span>
    </el-dialog>

    <!-- 导入文件 -->
    <el-dialog width="500px" title="批量导入考场" :visible="importVisible" @close="handleToCLoseImport">
      <el-form :model="importForm" label-width="80px">
        <el-form-item label="赛季" prop="season">
          <el-select
            placeholder="请选择"
            style="width: 100%"
            v-model="importForm.season"
          >
            <el-option
              v-for="item in dict_season"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赛区" prop="districtId">
          <el-select
            placeholder="请选择"
            style="width: 100%"
            v-model="importForm.districtId"
            @change="idChangeFn"
          >
            <el-option
              v-for="item in dict_district"
              :key="item.id"
              :label="item.districtName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考场类型" prop="roomType">
          <el-select
            placeholder="请选择"
            style="width: 100%"
            v-model="importForm.roomType"
          >
            <el-option
              v-for="item in roomTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="导入考场" prop="districtid">
          <el-upload
            ref="uploadFileRef"
            :action="uploadInfo.uploadUrl"
            :headers="uploadInfo.headerObj"
            :disabled="!importForm.districtId"
            :before-upload="beforeUpload"
            :limit="1"
            :auto-upload="false"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-change="uploadChange">
            <el-button :disabled="!importForm.districtId" class="mr-10" type="primary" size="small">选择文件</el-button>
          </el-upload>
          <el-link type="primary" @click="downLoadFn">下载模版</el-link>
        </el-form-item>
      </el-form>
      <div style="text-align: center; margin-top: 40px;">
        <el-button type="primary" @click="uploadExcel">确定上传</el-button>
      </div>
    </el-dialog>

    <!-- 修改线下选考场时间 -->
    <el-dialog title="修改选考场时间" :visible.sync="timeDialogVisible"
      width="600px"
      @close="handleCloseTimeDialog">
      <el-form
        label-width="130px"
        :model="editDistrictTimeForm"
        :rules="editDistrictTimeFormRules"
        ref="editDistrictTimeFormRef"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="选考场起止时间" prop="chooseRoomStartEndTime">
              <el-date-picker
                style="width: 100%"
                :default-time="['00:00:00', '23:59:59']"
                v-model="editDistrictTimeForm.chooseRoomStartEndTime"
                type="datetimerange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                @input="chooseRoomTimeChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="timeDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="saveDistrictTime">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryExaminationListPage, setExaminationTestPosition, updateExaminationRoom, queryDistrictPage, queryDistrictTimePage, saveOrUpdateDistrictTime, queryExaminationRoomInfo, addExaminationRoomInfo, importTemplatesTheSemiFinals } from '@/http/api'
export default {
  data () {
    return {
      dataList: [],
      total: 0,
      pageInfo: {
        pageNum: 1,
        pageSize: 10
      },
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        roomLevel: '',
        roomType: '',
        isClose: 1
      },
      // dict_district: this.$userInfo.getDataList(this, 't_district').then(value => { this.dict_district = value }),
      dict_district: [],
      dict_group: this.$userInfo.dict_group(),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      // roomTypeList: ['线下', '线上'],
      roomTypeList: this.$userInfo.match_type(),
      time_form: ['上午', '下午'],
      dialogVisible: false,
      dataFormRules: {
        season: [{ required: true, message: '请选择赛季', trigger: 'change' }],
        districtId: [{ required: true, message: '请选择赛区', trigger: 'change' }],
        roomLevel: [{ required: true, message: '请选择组别', trigger: 'change' }],
        roomName: [{ required: true, message: '请输入考场名称', trigger: 'blur' }],
        roomNum: [{ required: true, message: '请输入考位数量', trigger: 'blur' }],
        roomNotice: [{ required: true, message: '请输入注意事项', trigger: 'blur' }],
        roomAddress: [{ required: true, message: '请输入考场地址', trigger: 'blur' }],
        roomForm: [{ required: true, message: '请输入区域决选形式', trigger: 'blur' }],
        roomCertificate: [{ required: true, message: '请输入选区名称', trigger: 'blur' }],
        timeForm: [{ required: true, message: '请选择场次', trigger: 'change' }],
        roomType: [{ required: true, message: '请选择考场类型', trigger: 'change' }],
        dateRange: [{ required: true, message: '请选择比赛时间', trigger: 'change' }]
      },
      dataForm: {
        activityType: this.$chnEngStatusCode.activityType,
        districtId: '',
        districtName: '',
        id: '',
        roomAddress: '',
        roomEndTime: '',
        roomLevel: null,
        roomName: '',
        roomNotice: '',
        roomNum: '',
        roomStartTime: '',
        season: '',
        roomForm: '',
        timeForm: '',
        roomCertificate: '',
        roomType: ''
      },
      editType: 0, // 弹窗0新建1修改
      editId: 0,
      importVisible: false,
      importForm: {
        districtId: '',
        season: '',
        districtName: '',
        roomType: '',
        activityType: this.$chnEngStatusCode.activityType,
        file: null
      },
      uploadInfo: {
        uploadUrl: `${this.$http.defaults.baseURL}/examination/importTemplatesTheSemiFinals`,
        headerObj: {
          Authorization: window.sessionStorage.getItem('token')
        }
      },
      activeName: 'first',
      queryDistrictTimeForm: {
        raceSchedule: '2',
        districtTimeId: '',
        season: this.$chnEngStatusCode.defaultSeason,
        districtType: 0,
        schoolId: '',
        districtTimeName: '',
        pageNum: 1,
        pageSize: 10
      },
      divisionList: [],
      time_total: 0,
      timeDialogVisible: false,
      editDistrictTimeForm: {
        chooseRoomStartEndTime: null,
        chooseRoomStartTime: '',
        chooseRoomEndTime: ''
      },
      editDistrictTimeFormRules: {
        chooseRoomStartEndTime: [{ required: true, message: '请选择选考场起止时间', trigger: 'change' }]
      },
      setInfo: {
        roomAddress: '',
        roomForm: '',
        roomTime: '',
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        activityType: this.$chnEngStatusCode.activityType
      },
      districtName: '',
      setInfoFormRules: {
        roomForm: [{ required: true, message: '请输入区域决选形式', trigger: 'blur' }],
        // roomAddress: [{ required: true, message: '请输入考场地址', trigger: 'blur' }],
        roomTime: [{ required: true, message: '请选择考试开始日期', trigger: 'blur' }]
      }

    }
  },
  created () {
    this.dict_matchType = this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(value => { this.dict_matchType = value })
    this.getDistrictList()
    this.getList()
  },
  methods: {
    setInfoSave () {
      this.$refs.setInfoFormRef.validate(async valid => {
        if (!valid) return false
        const data = {
          activityType: this.queryForm.activityType,
          districtId: this.queryForm.districtId,
          districtName: this.districtName,
          season: this.queryForm.season
        }
        // this.setInfo.roomTime = this.$moment(this.setInfo.roomTime).format('YYYY-MM-DD HH:mm:ss')
        console.log(this.setInfo, data)
        addExaminationRoomInfo({ ...data, ...this.setInfo }).then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            if (this.setInfo.id === 0) {
              this.getGeneralInfo()
            }
          }
        })
      })
    },

    getGeneralInfo () {
      const { activityType, season, districtId } = this.setInfo
      queryExaminationRoomInfo({ activityType, season, districtId }).then(res => {
        if (res.data) {
          this.setInfo.roomAddress = res.data.roomAddress
          this.setInfo.roomForm = res.data.roomForm
          this.setInfo.roomTime = res.data.roomTime
          this.setInfo.id = res.data.id
        } else {
          // this.$refs.setInfoFormRef.resetFields()
          this.setInfo.roomAddress = ''
          this.setInfo.roomForm = ''
          this.setInfo.roomTime = ''
        }
      })
    },
    goBack () {
      this.$router.back()
    },
    levelFormat (row) {
      return row.roomLevel ? this.dict_group.find(item => Number(item.dictValue) === row.roomLevel).dictLabel : '-'
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        // this.queryForm.districtId = this.dict_district[0].id
        this.districtName = this.dict_district[0].districtName
        this.setInfo.districtId = this.dict_district[0].id
        // this.getGeneralInfo()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    districtChange (e) {
      this.districtName = this.dict_district.find(item => item.id === e).districtName
      this.changeFn()
    },
    handleToSearch () {
      this.pageInfo.pageNum = 1
      this.getList()
      this.getGeneralInfo()
    },
    handleToReset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
      this.getGeneralInfo()
    },
    async getList () {
      const params = { ...this.queryForm, ...this.pageInfo }
      queryExaminationListPage(params).then(res => {
        this.dataList = res.data.list
        this.total = res.data.total
      })
    },
    async exportExcel () {
      if (!this.queryForm.districtId) return this.$message.warning('请选择赛区')
      const downLoadUrl = `${this.$http.defaults.baseURL}examination/excelQueryExaminationListPage?${this.$xcUtils.serialize(this.queryForm)}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    showImportDialog () {
      this.importVisible = true
      this.importForm.districtId = this.queryForm.districtId
      this.importForm.districtName = this.dict_district.find(item => item.id === this.queryForm.districtId).districtName
      this.importForm.season = this.queryForm.season
      this.importForm.roomType = this.queryForm.roomType
    },
    uploadExcel () {
      if (!this.importForm.file) {
        return this.$message.warning('请选择文件')
      }
      const formData = new FormData()
      Object.keys(this.importForm).forEach(key => {
        const value = this.importForm[key]
        console.log(key, value)
        formData.append(key, value)
      })
      console.log(formData)
      importTemplatesTheSemiFinals(formData).then(res => {
        this.$message.success('上传成功')
        this.importForm.file = null
        this.importVisible = false
        this.getList()
      })
    },
    handleToCLoseImport () {
      this.importVisible = false
      this.$refs.uploadFileRef.clearFiles()// 清除文件
      this.importForm.districtid = ''
    },
    idChangeFn (id) {
      this.importForm.districtName = this.dict_district.find(item => item.id === id).districtName
    },
    uploadChange (file, fileList) {
      if (file) {
        this.importForm.file = file.raw
      }
    },
    beforeUpload (file) {
      if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error('请选择excel文件上传')
        return false
      }
    },
    uploadSuccess (res) {
      if (res.code === 0) {
        this.$message.success('文件上传成功')
        this.handleToSearch()
        this.handleToCLoseImport()
      } else {
        this.$message.error(res.message)
        this.$refs.uploadFileRef.clearFiles()// 清除文件
      }
    },
    uploadError (error) {
      console.log('uploadError', error)
    },
    async downLoadFn () {
      const downLoadUrl = `${this.$http.defaults.baseURL}examination/excelTemplatesTheSemiFinals`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    handleToCreate () {
      this.editType = 0
      this.dialogVisible = true
      this.dataForm.roomType = this.queryForm.roomType
    },
    handleCloseDialog () {
      this.dataForm = {
        activityType: this.$chnEngStatusCode.activityType,
        districtId: '',
        districtName: '',
        id: '',
        roomAddress: '',
        roomEndTime: '',
        roomLevel: '',
        roomName: '',
        roomNotice: '',
        roomNum: '',
        roomStartTime: '',
        season: '',
        roomForm: '',
        timeForm: '',
        roomCertificate: '',
        roomType: ''
      }
      if (this.hideUploadAdd) this.hideUploadAdd = false
      this.$refs.dataFormRef.resetFields()
      this.dialogVisible = false
    },
    handleSizeChange (e) {
      this.pageInfo.pageSize = e
      this.getList()
    },
    handleCurrentChange (e) {
      this.pageInfo.pageNum = e
      this.getList()
    },
    async showEditDialog (row) {
      Object.keys(this.dataForm).forEach(key => {
        if (key === 'roomLevel') {
          this.dataForm[key] = String(row[key])
        } else {
          this.dataForm[key] = row[key]
        }
      })

      // 比赛时间处理
      const dateRange = []
      dateRange[0] = new Date(row.roomStartTime)
      dateRange[1] = new Date(row.roomEndTime)
      this.$set(this.dataForm, 'dateRange', dateRange)

      this.editId = row.id
      this.editType = 1
      this.dialogVisible = true
    },
    async stateChange (row) {
      const { id, isClose } = row
      setExaminationTestPosition({ id, isClose }).then(res => {
        this.getList()
      })
    },
    handleToSubmit () {
      this.$refs.dataFormRef.validate(async valid => {
        if (!valid) return false
        if (this.editType === 0) delete this.dataForm.id
        delete this.dataForm.dateRange
        Object.keys(this.dataForm).forEach(key => {
          if (key === 'roomNum' || key === 'roomLevel') {
            this.dataForm[key] = Number(this.dataForm[key])
          }
          if (key === 'roomStartTime' || key === 'roomEndTime') {
            this.dataForm[key] = this.$moment(this.dataForm[key]).format('YYYY-MM-DD HH:mm:ss')
          }
        })
        console.log(this.dataForm)
        updateExaminationRoom(this.dataForm).then(res => {
          this.$message.success('保存成功')
          this.handleCloseDialog()
          this.getList()
        })
      })
    },
    handleToDetails (row) {
      this.$router.push({
        path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_room_details',
        query: {
          id: row.id,
          rl: row.roomLevel,
          rt: row.roomType,
          season: this.queryForm.season,
          districtId: row.districtId
        }
      })
    },
    handleToReferee (row) {
      if (row.season === '2022~2023') {
        this.$router.push({
          path: '/academic_Management/rm',
          query: {
            id: row.id,
            r: '2', // 赛程-复赛
            d: row.districtId, // 赛区
            s: row.season, // 赛季
            flag: '3', // 2022~2023复赛
            group: '3'
          }
        })
      } else {
        this.$router.push({
          path: '/academic_Management/rm',
          query: {
            id: row.id,
            r: '2', // 赛程-复赛
            d: row.districtId, // 赛区
            s: row.season, // 赛季
            flag: '3-B', // 2024复赛平板答题
            group: '3'
          }
        })
      }
    },
    daterangeChange (e) {
      if (e.length === 2) {
        this.dataForm.roomStartTime = e[0]
        this.dataForm.roomEndTime = e[1]
      }
    },
    distChange (e) {
      this.dataForm.districtName = this.dict_district.find(item => item.id === e).districtName
    },
    tabHandleClick () {
      //
      if (this.activeName === 'first') {
        this.getList()
      } else if (this.activeName === 'second') {
        this.getQueryDistrictTimePage()
      } else if (this.activeName === 'third') {
        this.getGeneralInfo()
      }
    },
    changeFn () {
      this.getGeneralInfo()
    },
    handleTimeSizeChange (e) {
      this.queryDistrictTimeForm.pageSize = e
      this.getQueryDistrictTimePage()
    },
    handleTimeCurrentChange (e) {
      this.queryDistrictTimeForm.pageNum = e
      this.getQueryDistrictTimePage()
    },
    // 获取赛区列表数据
    getQueryDistrictTimePage () {
      this.$refs.queryDistrictTimeFormRef.validate(async valid => {
        if (!valid) return
        let formDatas = {}
        formDatas = this.queryDistrictTimeForm
        formDatas.districtType = 0
        queryDistrictTimePage(formDatas).then((res) => {
          this.divisionList = res.data.list
          this.time_total = res.data.total
        }).catch((err) => {
          console.log('err', err)
        })
      })
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryDistrictTimeFormRef.resetFields()
      this.getQueryDistrictTimePage()
    },
    // 比赛类型转文字
    matchTypeFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_matchType) {
        if (Object.hasOwnProperty.call(this.dict_matchType, key)) {
          const element = this.dict_matchType[key]
          if (element.id === data.raceSchedule + '') {
            temp = element.scheduleName
          }
        }
      }
      return temp
    },
    showEditDistrictTimeDialog (row) {
      console.log(row)
      this.editDistrictTimeForm = JSON.parse(JSON.stringify(row))
      this.editDistrictTimeForm.chooseRoomStartTime = row.chooseRoomStartTime || ''
      this.editDistrictTimeForm.chooseRoomEndTime = row.chooseRoomEndTime || ''
      this.editDistrictTimeForm.chooseRoomStartEndTime = []
      this.editDistrictTimeForm.chooseRoomStartEndTime.push(this.editDistrictTimeForm.chooseRoomStartTime)
      this.editDistrictTimeForm.chooseRoomStartEndTime.push(this.editDistrictTimeForm.chooseRoomEndTime)

      this.timeDialogVisible = true
    },
    handleCloseTimeDialog () {
      this.timeDialogVisible = false
    },
    // 修改和新增时间信息
    saveDistrictTime () {
      console.log('this.editDistrictTimeForm', this.editDistrictTimeForm)
      this.$refs.editDistrictTimeFormRef.validate(async valid => {
        if (!valid) return
        this.editDistrictTimeForm.districtType = 0
        // if (this.modifyType === 'add' && this.activeName === 'first') {
        //   this.editDistrictTimeForm.districtTimeName = this.$refs.districtSelectRef.selectedLabel
        // }
        // if (this.modifyType === 'add' && this.activeName === 'second') {
        //   this.editDistrictTimeForm.districtTimeName = this.$refs.schoolSelectRef.selectedLabel
        // }
        saveOrUpdateDistrictTime(this.editDistrictTimeForm).then((res) => {
          console.log('saveOrUpdateDistrictTime', res)
          this.timeDialogVisible = false
          this.getQueryDistrictTimePage()
        }).catch((err) => {
          console.log('err1111', err)
        })
      })
    },
    chooseRoomTimeChange (e) {
      if (this.editDistrictTimeForm.chooseRoomStartEndTime && this.editDistrictTimeForm.chooseRoomStartEndTime.length === 2) {
        this.editDistrictTimeForm.chooseRoomStartTime = this.editDistrictTimeForm.chooseRoomStartEndTime[0]
        this.editDistrictTimeForm.chooseRoomEndTime = this.editDistrictTimeForm.chooseRoomStartEndTime[1]
      } else {
        this.editDistrictTimeForm.chooseRoomStartEndTime = null
      }
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="less" scoped>
.mr-10{
  margin-right: 10px;
}
.div_algin_right{
  text-align: right;
}
::v-deep .el-tabs--card>.el-tabs__header{
  background: #fff;
  margin-bottom: 0;
  border-bottom: none;
  border-top-left-radius: 4px;
}
::v-deep .el-input.is-disabled .el-input__inner, ::v-deep .el-textarea.is-disabled .el-textarea__inner{
  // background-color: #fff !important;
  color: #606266 !important;
}
</style>
